"use client";
import React from "react";
import Container from "./Container";
import Paragraph from "./Paragraph";

export default function About() {

    return (
        <section
            id="about" className="relative py-24 md:py-0 h-screen flex flex-col items-center bg-likeblack "
        >
            <Container className="my-auto relative" >
                <h2 className="text-6xl lg:text-9xl text-[#ffffff] mb-6 font-nebulica font-semibold lg:font-extrabold lg:mb-8">
                    ABOUT <span className="bg-lemone text-smoke">ME</span></h2>
                <Paragraph className="text-xl text-neutral-50 md:w-[640px] lg:w-[840px] xl:w-[940px] 2xl:w-[1200px] 4xl:w-[1400px] text-justify">
                    I`am <strong className="text-primary font-semibold"> Surya</strong>, I have over three years of experience as a frontend developer, currently employed at a software house. In addition to my full-time role, I also freelance. My journey with coding began in junior high school, where I initially explored Blogger and created custom designs with added elements.
                </Paragraph>
            </Container>
            <div className="hidden md:block md:absolute right-0 bottom-4 md:bottom-24 h-20 md:h-[120px] 4xl:h-[160px]">
                <img className="w-full h-full" src={"../../pettern/square-off-white.svg"} alt="" width={800} height={800} />
            </div>
        </section >
    );
} 